import { createSelector } from 'reselect'

export const getProducts = createSelector(
  (state) => state && state.ads && state.ads.products && state.ads.products.elements && Array.isArray(state.ads.products.elements)
    ? state.ads.products.elements
    : [],
  (products) => products
)
